<template>
  <card class="goods-info">
    <div class="order-info-title">
      <AdminTitle title="订单信息" size="20px"> </AdminTitle>
    </div>
    <div class="goods-info-detail">
      <el-image
        style="
          width: 100px;
          border-radius: 8px;
          height: 100px;
          margin-right: 20px;
        "
        :src="
          detailInfo.orderGoods   ? detailInfo.orderGoods.skuCoverImageUrl : ''
        "
        :preview-src-list="[
          detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : '',
        ]"
      >
        <div
          style="
            background: #f5f7fa;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #c0c4cc;
          "
          slot="error"
        >
          暂无图片
        </div>
      </el-image>
      <div class="goods-info-detail-right">
        <div class="goods-title fw700">
          {{ detailInfo.orderGoods ? detailInfo.orderGoods.skuTitle : "" }}
        </div>
        <div class="order-tag">
          <el-tag
              :type="detailInfo.orderGoods && detailInfo.orderGoods.goodsPurityName
                ? detailInfo.orderGoods.goodsPurityName == '全新' ? 'success' : 'warning'
                : 'success'"
          >
            {{ detailInfo.orderGoods ? detailInfo.orderGoods.goodsPurityName : "" }}
          </el-tag>
          <el-tag type="success">{{ detailInfo.orderTypeName }}</el-tag>

          <el-tag type="danger" v-if="detailInfo.withholdChannel === 1">免押</el-tag>

          <el-tag type="info">{{ detailInfo.statusName }}</el-tag>
        </div>
        <div class="label">订单号：{{ $route.params.id }}</div>
        <div class="label">下单时间：{{ detailInfo.createTime }}</div>
      </div>
    </div>
    <div class="cost-details">
      <div class="cost-title">费用明细</div>
    </div>
    <card class="goods-info special-card">
      <el-row>
        <el-col
          :span="item.width ? item.width : 8"
          v-for="(item, index) in orderInfoList"
          :key="index"
        >
            <span class="label" :style="item.customLabelStyle">{{ item.label }}</span>
            <span
              class="value"
              :style="item.customPropStyle"
              v-if="!item.customRender"
            >
              {{ detailInfo[item.prop] || "" }}{{ item.unit }}
            </span>
            <span class="value" :style="item.customPropStyle" v-else>
              {{ item.customRender(detailInfo) }}
            </span>
            <!-- 费率 -->
            <i
              v-if="
                !rejectOnly && item.edit &&
                item.prop == 'storeComboName' &&
                (detailInfo.orderType == 2 || detailInfo.orderType == 4) &&
                isShowBtn(AUTH_BTN.review_list_detail_update_price_rate)
              "
              @click="updateOrderCombo"
              class="el-icon-edit"
            >
              修改</i
            >
            <!-- 零售价 -->
            <i
              v-if="
                !rejectOnly && item.edit &&
                item.prop == 'salePrice' &&
                isShowBtn(AUTH_BTN.review_list_detail_update_cost_price)
              "
              @click="updatePrice"
              class="el-icon-edit"
            >
              修改</i
            >
        </el-col>
      </el-row>
    </card>

    <!-- 零售价 -->
    <el-dialog
      title="修改零售价"
      :visible.sync="priceDialog"
      width="550px"
      custom-class="retail-price-dialog"
    >
      <!-- 当前方案最高售价提示条 -->
      <div
        v-if="showMaxLimitTip"
        class="max-price-tip dialog-max-price-tip"
      >
        <i class="el-icon-warning"></i>
        <span class="tip-text">新零售价超出当前方案最高售价，请谨慎操作</span>
      </div>
      <el-form ref="periodForm" :model="priceData" label-width="120px">
        <el-form-item label="方案最高售价：">
          <span style="color: #606266; font-size: 14px">
            {{ detailInfo.maxLimitPrice ? detailInfo.maxLimitPrice : '' }} 元
          </span>
        </el-form-item>
        <el-form-item label="商品售价区间：">
          <span style="color: #606266; font-size: 14px">
            {{ detailInfo.orderGoods ? detailInfo.orderGoods.minSalePrice : '' }} -
            {{ detailInfo.orderGoods ? detailInfo.orderGoods.maxSalePrice : '' }} 元
          </span>
        </el-form-item>
        <el-form-item
          label="新零售价："
          prop="salePrice"
          :rules="[
            { required: true, message: '请输入新零售价', trigger: 'blur' },
            { validator: validateSalePrice, trigger: 'blur' },
          ]"
        >
          <el-input-number
            style="width: 200px"
            v-model="priceData.salePrice"
            size="small"
            :precision="2"
            :min="0"
            @input.native="onNewPriceInput"
            @change="newPriceRaw = null"
          ></el-input-number>
          <span style="margin-left: 8px; color: #909399">元</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="priceDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="savePrice" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <EditCombo
      :customer-name="detailInfo.member ? detailInfo.member.memberName : ''"
      :customer-mobile="detailInfo.member ? detailInfo.member.mobile : ''"
      :orderNo="detailInfo.orderNo"
      :comboId="detailInfo.storeComboId"
      :comboRoute="detailInfo.storeComboRoute"
      :visible.sync="editComboProps.visible"
      @refresh="refresh"
    />
  </card>
</template>

<script>
import { updatePriceAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import EditCombo from "./edit-combo/index.vue";

export default {
  components: { EditCombo },
  name: "OrderInfo",
  props: {
    rejectOnly: Boolean,
    detailInfo: {
      type: Object,
      default: () => {},
    },
    flag: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [authBtnMixin],
  data() {
    return {
      priceData: {
        salePrice: "",
        orderNo: "",
      },
      // 新零售价输入框当前实时输入值
      newPriceRaw: null,
      orderInfoList: [
        {
          label: "总租金",
          prop: "rentPrice",
          unit: "元",
        },
        {
          label: "首付金额",
          prop: "prepayAmount",
          unit: "元",
        },
        {
          label: "方案",
          prop: "storeComboName",
          edit: true,
        },
        {
          label: "租期",
          prop: "billPeriodNum",
          unit: "期",
        },
        {
          label: "首期租金",
          prop: "prepayRentPrice",
          unit: "元",
        },
        {
          label: "零售价",
          prop: "salePrice",
          unit: "元",
          edit: true,
        },
        {
          label: "买断金",
          prop: "buyoutPrice",
          unit: "元",
        },
        {
          label: "押金",
          prop: "prepayDepositPrice",
          unit: "元",
        },
        {
          label: "方案最高售价",
          prop: "maxLimitPrice",
          unit: "",
          customRender: (row) => {
            const maxLimitPrice = row?.maxLimitPrice || '-';
            return `${maxLimitPrice} 元`;
          },
          customLabelStyle: "color: red;",
          customPropStyle: "color: red;",
        },
        {
          label: "监管锁费",
          prop: "lockAmount",
          unit: "元",
        },
        {
          label: "保险金",
          prop: "insurancePrice",
          unit: "元",
        },
        {
          label: "商品售价区间",
          prop: "priceRange",
          unit: "",
          customRender: (row) => {
            const minPrice = row.orderGoods?.minSalePrice || 0;
            const maxPrice = row.orderGoods?.maxSalePrice || 0;
            return `${minPrice} - ${maxPrice} 元`;
          },
          customLabelStyle: "color: red;",
          customPropStyle: "color: red;",
        },
      ],
      priceDialog: false,
      editComboProps: {
        visible: false,
      },
    };
  },
  computed: {
    showMaxLimitTip() {
      const maxLimit = Number(this.detailInfo.maxLimitPrice);
      if (!maxLimit) return false;

      let value;
      if (this.newPriceRaw !== null) {
        const raw = String(this.newPriceRaw).trim();
        if (raw === "") return false;
        value = parseFloat(raw);
      } else {
        value = Number(this.priceData.salePrice);
      }

      return !Number.isNaN(value) && value > maxLimit;
    },
  },

  methods: {
    onNewPriceInput(e) {
      this.newPriceRaw = e.target.value;
    },
    // 零售价校验
    validateSalePrice(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error("请输入新零售价"));
        return;
      }

      const maxSalePrice = this.detailInfo.orderGoods?.maxSalePrice;
      const minSalePrice = this.detailInfo.orderGoods?.minSalePrice;

      if (maxSalePrice && value > maxSalePrice) {
        callback(new Error(`新零售价超出商品最高售价，请检查后重新录入`));
        return;
      }

      if (minSalePrice && value < minSalePrice) {
        callback(new Error(`新零售价低于商品最低售价，请检查后重新录入`));
        return;
      }

      callback();
    },
    // 保存零售价
    savePrice() {
      this.$refs.periodForm.validate((valid) => {
        if (valid) {
          updatePriceAPI(this.priceData).then(() => {
            localStorage.setItem("is_update_period", "true");
            this.$emit("update:flag", false);
            this.$emit("updateDetail");
            this.$message.success("修改成功");
            this.priceDialog = false;
          });
        } else {
          return false;
        }
      });
    },
    // 打开修改零售价
    updatePrice() {
      this.priceData.orderNo = this.$route.params.id;
      this.priceData.salePrice = this.detailInfo.salePrice;
      this.newPriceRaw = null;
      this.priceDialog = true;
      // 重置表单验证状态
      this.$nextTick(() => {
        if (this.$refs.periodForm) {
          this.$refs.periodForm.clearValidate();
        }
      });
    },
    // 打开方案修改窗口。
    updateOrderCombo() {
      this.editComboProps.visible = true;
    },
    refresh() {
      this.$emit("updateDetail");
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-info /deep/ {
  border-color: transparent;
  margin-top: 20px;
  width: 100%;
  border-radius: 16px;
  color: #222222;
  .order-info-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .label {
    color: #666666;
    font-size: 14px;
  }
  .ivu-card {
    border-radius: 18px;
  }
  .goods-info-detail {
    display: flex;
    .goods-info-detail-right {
      display: flex;
      flex-direction: column;
      .goods-title {
        color: #333333;
        font-size: 16px;
      }
      .order-tag {
        margin-top: 8px;
      }
      .label {
        margin-top: 8px;
        font-size: 12px;
      }
    }
    .el-tag {
      height: 25px;
      border-radius: 15px;
      margin-right: 10px;
      line-height: 25px;
    }
    .el-tag.el-tag--success {
      background-color: #fff;
      color: #666666;
      border-color: #e4e4e4;
    }

    .el-tag.el-tag--warning {
      background-color: #fff;
      color: #f15f5f;
      border-color: #f15f5f;
    }
    .el-tag.el-tag--info {
      background-color: #fff;
      color: #ffac46;
      border-color: #ffac46;
    }
  }
  .cost-details {
    .cost-title {
      margin-top: 15px;
      color: #666666;
      font-size: 14px;
    }
  }
  .el-dialog__footer {
    padding-bottom: 30px !important;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-style {
      color: #333333;
      flex-wrap: 600;
      font-size: 16px;
    }
    .supple-inform-edit {
      cursor: pointer;
      background: #f7f8fa;
      color: #333333;
      padding: 8px 18px;
      border-radius: 45px;
    }
  }

  .update-final-grade-dialog {
    .el-dialog__footer {
      padding-top: 0;
    }
  }
}
.special-card {
  background: #f7f8fa;
  line-height: 35px;
  color: #222222;
  position: relative;
  .value {
    margin-left: 15px;
    min-width: 80px;
    display: inline-block;
    font-weight: 700;
  }
  .label {
    text-align: right;
    min-width: 90px;
    display: inline-block;
  }
  .el-icon-edit {
    margin-left: 30px;
    cursor: pointer;
    color: #4badf8;
  }
  &::after {
    content: "";
    display: inline-block;
    height: 80%;
    width: 1px;
    border-left: 1px dashed #e4e4e4;
    right: 36%;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }
}
/* 当前方案最高售价提示条 */
.max-price-tip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
  padding: 2px 12px;
  background-color: #fef0f0;
  border-radius: 8px;

  .el-icon-warning {
    color: red;
    font-size: 15px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .tip-text {
    color: red;
    font-size: 13px;
    font-weight: 500;
  }

  .tip-price {
    color: red;
    font-size: 15px;
    font-weight: 700;
    margin-left: 4px;
  }
}
.dialog-max-price-tip {
  margin-bottom: 12px;
}
/* 修改零售价弹窗内表单项垂直间距缩小 */
.retail-price-dialog {
  .el-form-item {
    margin-bottom: 8px;
  }
}
.sale-price-warning {
  margin-top: 4px;
  font-size: 12px;
  color: #f56c6c;
  line-height: 1.5;

  .el-icon-warning {
    margin-right: 4px;
  }
}
.fw700 {
  font-weight: 700;
}
</style>
